"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
class EmptyDelegate {
  async init() {
    return this;
  }
  exists(key, dval, options) {
    return false;
  }
  t(key, dval, options) {
    return typeof dval === 'string' ? dval : key;
  }
}
exports.default = EmptyDelegate;